/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@kubb/plugin-client/clients/fetch";
import type { GetDrawingStatusQueryResponse, GetDrawingStatusPathParams, GetDrawingStatus422 } from "../models/drawingClient/GetDrawingStatus";
import type { RequestConfig, ResponseErrorConfig } from "@kubb/plugin-client/clients/fetch";

function getGetDrawingStatusUrl(project_uuid: GetDrawingStatusPathParams["project_uuid"], file_uuid: GetDrawingStatusPathParams["file_uuid"]) {
  const res = { method: 'GET', url: `/v1/drawings/${project_uuid}/${file_uuid}/status` as const }  
  return res
}

/**
 * @description Returns a JSON object with the status of the drawing regarding processing and availability of the drawing files.
 * @summary Get the status of a drawing
 * {@link /v1/drawings/:project_uuid/:file_uuid/status}
 */
export async function getDrawingStatus(project_uuid: GetDrawingStatusPathParams["project_uuid"], file_uuid: GetDrawingStatusPathParams["file_uuid"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetDrawingStatusQueryResponse, ResponseErrorConfig<GetDrawingStatus422>, unknown>({ method : "GET", url : getGetDrawingStatusUrl(project_uuid, file_uuid).url.toString(), ... requestConfig })  
  return res.data
}